import React from 'react';

export interface SelectPromptBannerProps {
  show: boolean;
}

export const SelectPromptBanner: React.FC<SelectPromptBannerProps> = ({ show }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none px-4">
      <div
        role="status"
        aria-live="polite"
        className="pointer-events-auto rounded-lg border border-purple-200 bg-white px-6 py-4 text-center shadow-xl"
      >
        <p className="text-sm font-semibold text-gray-900">Please select influencers first</p>
        <p className="mt-1 text-xs text-gray-500">
          Choose one or more influencers, then click Refresh All.
        </p>
      </div>
    </div>
  );
};
